<p-dialog
  [visible]="visible()"
  (visibleChange)="onVisibleChange($event)"
  [modal]="true"
  [style]="{ width: '32rem' }"
  [header]="dialogTitle() | translate"
  [draggable]="false"
  [resizable]="false"
  [closable]="true">
  <div class="measure-unit-form">
    @if (generalError(); as error) {
      <p class="dialog-error" role="alert">{{ error }}</p>
    }
    <div class="form-field">
      <label for="measureUnitName">
        {{ 'SETTINGS_MEASURE_UNITS.NAME' | translate }}
        <span class="required">*</span>
      </label>
      <input
        pInputText
        id="measureUnitName"
        type="text"
        [formField]="measureUnitForm.name"
        [placeholder]="'SETTINGS_MEASURE_UNITS.NAME_PLACEHOLDER' | translate"
        class="w-full"
        [class.ng-invalid]="!!serverErrors.value()['name']"
        [attr.aria-invalid]="serverErrors.value()['name'] ? true : null"
        [attr.aria-describedby]="serverErrors.value()['name'] ? 'measureUnitName-error' : null" />
      @if (measureUnitForm.name().touched() && measureUnitForm.name().invalid()) {
        <small class="p-error">{{ measureUnitForm.name().errors()[0]?.message | translate }}</small>
      }
      @if (serverErrors.value()['name']; as error) {
        <small class="p-error" id="measureUnitName-error" role="alert">{{ error }}</small>
      }
    </div>

    <div class="form-field">
      <label for="measureUnitSymbol">
        {{ 'SETTINGS_MEASURE_UNITS.SYMBOL' | translate }}
        <span class="required">*</span>
      </label>
      <input
        pInputText
        id="measureUnitSymbol"
        type="text"
        [formField]="measureUnitForm.symbol"
        [placeholder]="'SETTINGS_MEASURE_UNITS.SYMBOL_PLACEHOLDER' | translate"
        class="w-full"
        [class.ng-invalid]="!!serverErrors.value()['symbol']"
        [attr.aria-invalid]="serverErrors.value()['symbol'] ? true : null"
        [attr.aria-describedby]="
          serverErrors.value()['symbol'] ? 'measureUnitSymbol-error' : null
        " />
      @if (measureUnitForm.symbol().touched() && measureUnitForm.symbol().invalid()) {
        <small class="p-error">
          {{ measureUnitForm.symbol().errors()[0]?.message | translate }}
        </small>
      }
      @if (serverErrors.value()['symbol']; as error) {
        <small class="p-error" id="measureUnitSymbol-error" role="alert">{{ error }}</small>
      }
    </div>
  </div>

  <ng-template #footer>
    <div class="flex gap-2 justify-content-end">
      <p-button
        [label]="'GENERAL.CANCEL' | translate"
        severity="secondary"
        [outlined]="true"
        [disabled]="isSaving()"
        (onClick)="onCancel()" />
      <p-button
        [label]="'GENERAL.SAVE' | translate"
        severity="primary"
        [loading]="isSaving()"
        [disabled]="measureUnitForm().invalid() || isSaving()"
        (onClick)="onSave()" />
    </div>
  </ng-template>
</p-dialog>
